"use client";

import * as React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { motion } from "framer-motion";

export function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <div className="w-9 h-9" />; // Placeholder to avoid layout shift
  }

  return (
    <button
      type="button"
      onClick={(e) => {
        // Prevent event bubbling just in case
        e.stopPropagation();
        // Force toggle logic: prefer resolvedTheme but fallback to theme
        const current = resolvedTheme || theme;
        const next = current === "dark" ? "light" : "dark";
        setTheme(next);
      }}
      className="relative z-50 w-10 h-10 p-2 rounded-full hover:bg-black/5 dark:hover:bg-white/10 transition-colors text-(--text-primary) cursor-pointer flex items-center justify-center pointer-events-auto"
      aria-label="Toggle Theme"
      suppressHydrationWarning
    >
      <motion.div
        initial={false}
        animate={{
          rotate: resolvedTheme === "dark" ? 0 : 180,
          scale: resolvedTheme === "dark" ? 1 : 0,
        }}
        className="absolute inset-0 flex items-center justify-center pointer-events-none"
      >
        <Moon className="w-5 h-5" />
      </motion.div>
      <motion.div
        initial={false}
        animate={{
          rotate: resolvedTheme === "light" ? 0 : -180,
          scale: resolvedTheme === "light" ? 1 : 0,
        }}
        className="flex items-center justify-center pointer-events-none"
      >
        <Sun className="w-5 h-5" />
      </motion.div>
    </button>
  );
}
